import { render, staticRenderFns } from "./CouponsList.vue?vue&type=template&id=2527c8a4&scoped=true"
import script from "./CouponsList.vue?vue&type=script&lang=js"
export * from "./CouponsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527c8a4",
  null
  
)

export default component.exports